import store from '@/store/index'


let ybjb = [
    {
        value: '干眼症',
        label: '干眼症'
    },
    {
        value: '结膜炎',
        label: '结膜炎'
    },
    {
        value: '角膜炎',
        label: '角膜炎'
    },
    {
        value: '虹膜炎',
        label: '虹膜炎'
    },
    {
        value: '球结膜炎症',
        label: '球结膜炎症'
    },
    {
        value: '睑缘炎',
        label: '睑缘炎'
    },
    {
        value: '麦粒肿',
        label: '麦粒肿'
    },
    {
        value: '霰粒肿',
        label: '霰粒肿'
    }
]

let qgbz = [
    {
        value: '屈光不正',
        label: '屈光不正'
    },
    {
        value: '近视',
        label: '近视'
    },
    {
        value: '远视',
        label: '远视'
    },
    {
        value: '散光',
        label: '散光'
    },
    {
        value: '老视',
        label: '老视'
    },
]

let jtjb = [
    {
        value: '白内障',
        label: '白内障'
    }
]

let bltjb = [
    {
        value: '玻璃体浑浊',
        label: '玻璃体浑浊'
    },
    {
        value: '飞蚊症',
        label: '飞蚊症'
    },
]

let swmjb = [
    {
        value: '视网膜脱离',
        label: '视网膜脱离'
    },
    {
        value: '视网膜裂孔',
        label: '视网膜裂孔'
    },
    {
        value: '年龄相关黄斑变性',
        label: '年龄相关黄斑变性'
    },
    {
        value: '糖尿病性视网膜病变',
        label: '糖尿病性视网膜病变'
    },
    {
        value: '视网膜血管阻塞',
        label: '视网膜血管阻塞'
    },
    {
        value: '近视视网膜病变',
        label: '近视视网膜病变'
    },

]

let ssjjb = [
    {
        value: '视神经炎',
        label: '视神经炎'
    },
    {
        value: '缺血性视神经病变',
        label: '缺血性视神经病变'
    },
]

let ywjhykjb = [
    {
        value: '斜视',
        label: '斜视'
    },
    {
        value: '弱视',
        label: '弱视'
    },
    {
        value: '甲状腺相关疾病',
        label: '甲状腺相关疾病'
    },
]


let yws = [
    {
        value: '角膜异物',
        label: '角膜异物'
    },
    {
        value: '眼球钝挫伤',
        label: '眼球钝挫伤'
    },
    {
        value: '眼球穿通伤',
        label: '眼球穿通伤'
    },
    {
        value: '化学烧伤',
        label: '化学烧伤'
    },
]

let qtjb = [
    {
        value: '角膜上皮缺损',
        label: '角膜上皮缺损'
    },
    {
        value: '眼底出血',
        label: '眼底出血'
    },
    {
        value: '沙眼',
        label: '沙眼'
    },
    {
        value: '夜盲症',
        label: '夜盲症'
    },
    {
        value: '翼状胬肉',
        label: '翼状胬肉'
    },
    {
        value: '眼结石',
        label: '眼结石'
    },
    {
        value: '泪囊炎',
        label: '泪囊炎'
    },
    {
        value: '倒睫',
        label: '倒睫'
    },
]

let qgys = [
    {
        value: '开角型清光眼',
        label: '开角型清光眼'
    },
    {
        value: '闭角型青光眼',
        label: '闭角型青光眼'
    },
]

function ypsl() {
    let arr = []
    for (let i = 1; i < 100; i++) {
        arr.push({
            value: i,
            label: i
        })
    }
    return arr
}

function getcsz(str) {
    return {
        ChooseProductId: '',
        CHPProductSortGroup: str,
        CHPChooseId: store.state.physicianVisits.xzConsulting,
        CHPPrescriptionData: '',
        CHPS_OP_ALL_Id: '00000000-0000-0000-0000-000000000000',
        CHPAmount: 1,
        CHPProductId: '',
        CHPPrice: '',
        CHPRequirements: '',
        CHPProductSource: '',
        CHPExpertId: store.state.users.employees.ExpertId,
        CHPRemark: '',
        ProductRelation: {
            ProductDetail: {
                AllProduct: {}
            },
            ShopProduct: {
                SPAmount: '',
                SPbNoCountSale: false
            }
        }
    }
}










let ypxzarr = {
    cishu: [
        { "value": "每天一次（qd）", "label": "每天一次（qd）" },
        { "value": "每天二次（bid）", "label": "每天二次（bid）" },
        { "value": "每天三次（tid）", "label": "每天三次（tid）" },
        { "value": "每天四次（qid）", "label": "每天四次（qid）" },
        { "value": "每周一次（qw）", "label": "每周一次（qw）" },
        { "value": "每周二次（biw）", "label": "每周二次（biw）" },
        { "value": "每周三次（tiw）", "label": "每周三次（tiw）" },
        { "value": "每小时一次（qh）", "label": "每小时一次（qh）" },
        { "value": "每2小时一次（q2h）", "label": "每2小时一次（q2h）" },
        { "value": "每4小时一次（q4h）", "label": "每4小时一次（q4h）" },
        { "value": "每5小时一次（q5h）", "label": "每5小时一次（q5h）" },
        { "value": "每6小时一次（q6h）", "label": "每6小时一次（q6h）" },
        { "value": "每8小时一次（q8h）", "label": "每8小时一次（q8h）" },
        { "value": "每12小时一次（q12h）", "label": "每12小时一次（q12h）" },
        { "value": "每晚一次（qn）", "label": "每晚一次（qn）" },
        { "value": "隔天一次（qod）", "label": "隔天一次（qod）" },
        { "value": "五天一次（q5d）", "label": "五天一次（q5d）" },
        { "value": "十天一次（q10d）", "label": "十天一次（q10d）" },
        { "value": "12小时维持", "label": "12小时维持" },
        { "value": "24小时维持", "label": "24小时维持" },
        { "value": "立即（st）", "label": "立即（st）" },
        { "value": "必要时使用（prn）", "label": "必要时使用（prn）" }
    ],
    shijian: [
        {
            value: '睡前',
            label: '睡前'
        },
        {
            value: '日间',
            label: '日间'
        },
        {
            value: '',
            label: ''
        },
    ],
    yyts: [
        {
            value: '1天',
            label: '1天'
        },

        {
            value: '2天',
            label: '2天'
        },
        {
            value: '3天',
            label: '3天'
        },
        {
            value: '4天',
            label: '4天'
        },
        {
            value: '5天',
            label: '5天'
        },
        {
            value: '6天',
            label: '6天'
        },
        {
            value: '7天',
            label: '7天'
        },
        {
            value: '10天',
            label: '10天'
        },
        {
            value: '2周',
            label: '2周'
        },
        {
            value: '3周',
            label: '3周'
        },
        {
            value: '1个月',
            label: '1个月'
        },
        {
            value: '3个月',
            label: '3个月'
        },
        {
            value: '半年',
            label: '半年'
        },
        {
            value: '长期',
            label: '长期'
        },
        {
            value: '',
            label: ''
        }
    ],
    yyfs: [
        {
            value: '口服',
            label: '口服'
        },
        {
            value: '外用',
            label: '外用'
        },
        {
            value: '外用冷敷',
            label: '外用冷敷'
        },
        {
            value: '外用热敷',
            label: '外用热敷'
        },
        {
            value: '滴眼',
            label: '滴眼'
        },
        {
            value: '涂抹',
            label: '涂抹'
        },
        {
            value: '',
            label: ''
        }
    ],
    yyyl: [
        {
            value: '一次1滴/片/粒',
            label: '一次1滴/片/粒'
        },
        {
            value: '一次2滴/片/粒',
            label: '一次2滴/片/粒'
        },
        {
            value: '一次3滴/片/粒',
            label: '一次3滴/片/粒'
        },
        {
            value: '',
            label: ''
        }
    ],
    yyyanbie: [
        {
            value: 'OU',
            label: 'OU'
        },
        {
            value: 'OS',
            label: 'OS'
        },
        {
            value: 'OD',
            label: 'OD'
        },
        {
            value: '',
            label: ''
        }
    ],
}




let cfObj = {
    cflx: [
        {
            value: '1',
            label: '框架远用'
        },
        {
            value: '2',
            label: '框架近用'
        },
        {
            value: '3',
            label: '角膜接触镜'
        }
    ],
    pdfs: [
        {
            value: '一直佩戴',
            label: '一直佩戴'
        },
        {
            value: '需要时戴',
            label: '需要时戴'
        },
        {
            value: '看近时戴',
            label: '看近时戴'
        },
        {
            value: '交替佩戴',
            label: '交替佩戴'
        },
        {
            value: ' ',
            label: ' '
        }
    ],
    czjd: [
        {
            value: '上',
            label: '上'
        },
        {
            value: '下',
            label: '下'
        },
    ],
    jd: [
        {
            value: '内',
            label: '内'
        },
        {
            value: '外',
            label: '外'
        }
    ],
    falx: [
        {
            value: '单光',
            label: '单光'
        },
        {
            value: '渐进',
            label: '渐进'
        },
        {
            value: '抗疲劳',
            label: '抗疲劳'
        },
        {
            value: '离焦',
            label: '离焦'
        },
        {
            value: '儿童多焦点',
            label: '儿童多焦点'
        },
        {
            value: '双光镜片',
            label: '双光镜片'
        },
    ],
    cfsfalx: [
        {
            value: 'SCL',
            label: 'SCL'
        },
        {
            value: 'RGP',
            label: 'RGP'
        },
        {
            value: 'OK镜片',
            label: 'OK镜片'
        },
    ]
}

function gbjh(val) {
    if (!val) return val
    val = val.toString()
    if (val.indexOf('-') > -1 || val.indexOf('+') > -1) return val
    if (val.indexOf('+') < 0) return '+'+val
    return val
}


//把JSON字符串转换成***的字符串
function conversionJson(json) {
    if (!json) {
        return ''
    }
    let str = JSON.stringify(json);
    str = str.replace(/"/g, '***')
    return str
}

function mbxx(arr) {
    let sparrs = []
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].CHPProductId) {
            sparrs.push({
                PTDProductId: arr[i].CHPProductId,
                PTDCount:  arr[i].CHPAmount,
                PTDPrescriptionData: arr[i].CHPPrescriptionData ? conversionJson(arr[i].CHPPrescriptionData) : '',
                PTDRemark: arr[i].CHPRemark,
                PTDInsuranceType: ''
            })
        }
    }

    return sparrs
}


export {
    ybjb,
    qgbz,
    jtjb,
    bltjb,
    swmjb,
    ssjjb,
    ywjhykjb,
    yws,
    qtjb,
    qgys,
    ypxzarr,
    ypsl,
    getcsz,
    cfObj,
    gbjh,
    mbxx
}
